module.exports = __webpack_public_path__ + "img/tab-icon7.ef457c95.png";